import React from 'react';
import {
  Box,
  Text,
  Flex,
  Modal,
  Button,
  Divider,
  ModalBody,
  ModalOverlay,
  ModalContent,
} from '@chakra-ui/react';
import { formatCurrency } from '../../utils/formatCurrency';

const ViewPayment = ({ isOpen, payment, onClose, size = 'xl' }) => {
  console.log('Payment', payment);
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={size}>
      <ModalOverlay />
      <ModalContent maxWidth={'800px'} borderRadius={'16px'} p={4}>
        <ModalBody gap={6} display={'flex'} flexDirection={'column'}>
          <Text
            fontSize={'24px'}
            fontFamily={'PlusJakartaSansSemiBold'}
            color={'#000000'}
          >
            View Payment
          </Text>
          <Divider borderWidth={'1px'} width={'100%'} color={'#8A8F9333'} />
          <Box>
            <Text
              fontSize={'16px'}
              fontFamily={'PlusJakartaSansSemiBold'}
              color={'#000000'}
              pb={2}
            >
              Payment Details
            </Text>
            <Box
              borderRadius={'6px'}
              padding={'16px'}
              border={'1px solid #D9D9D9'}
            >
              <Flex mb={5}>
                <Flex flex={1} flexDir={'column'}>
                  <Text
                    fontSize={'12px'}
                    fontFamily={'PlusJakartaSansMedium'}
                    lineHeight={'16px'}
                    color={'#B4BBC3'}
                  >
                    Payment ID:
                  </Text>
                  <Text
                    fontSize={'12px'}
                    fontFamily={'PlusJakartaSansMedium'}
                    lineHeight={'16px'}
                    color={'#000000'}
                  >
                    {payment?.id}
                  </Text>
                </Flex>
                <Flex flex={1} flexDir={'column'}>
                  <Text
                    fontSize={'12px'}
                    fontFamily={'PlusJakartaSansMedium'}
                    lineHeight={'16px'}
                    color={'#B4BBC3'}
                  >
                    Date
                  </Text>
                  <Text
                    fontSize={'12px'}
                    fontFamily={'PlusJakartaSansMedium'}
                    lineHeight={'16px'}
                    color={'#000000'}
                  >
                    {payment?.date_created
                      ? payment?.date_created.split('T')[0]
                      : ''}
                  </Text>
                </Flex>
              </Flex>
              <Flex mb={5}>
                <Flex flex={1} flexDir={'column'}>
                  <Text
                    fontSize={'12px'}
                    fontFamily={'PlusJakartaSansMedium'}
                    lineHeight={'16px'}
                    color={'#B4BBC3'}
                  >
                    Seller Name:
                  </Text>
                  <Text
                    fontSize={'12px'}
                    fontFamily={'PlusJakartaSansMedium'}
                    lineHeight={'16px'}
                    color={'#000000'}
                  >
                    {payment?.payee_id?.first_name +
                      ' ' +
                      payment?.payee_id?.surname}
                  </Text>
                </Flex>
                <Flex flex={1} flexDir={'column'}>
                  <Text
                    fontSize={'12px'}
                    fontFamily={'PlusJakartaSansMedium'}
                    lineHeight={'16px'}
                    color={'#B4BBC3'}
                  >
                    Payment Amount:
                  </Text>
                  <Text
                    fontSize={'12px'}
                    fontFamily={'PlusJakartaSansMedium'}
                    lineHeight={'16px'}
                    color={'#000000'}
                  >
                    {formatCurrency(payment?.amount)}
                  </Text>
                </Flex>
              </Flex>
              <Flex mb={5}>
                <Flex flex={1} flexDir={'column'}>
                  <Text
                    fontSize={'12px'}
                    fontFamily={'PlusJakartaSansMedium'}
                    lineHeight={'16px'}
                    color={'#B4BBC3'}
                  >
                    Paid from bank:
                  </Text>
                  <Text
                    fontSize={'12px'}
                    fontFamily={'PlusJakartaSansMedium'}
                    lineHeight={'16px'}
                    color={'#000000'}
                  >
                    {payment?.paidFromBank}
                  </Text>
                </Flex>
                <Flex flex={1} flexDir={'column'}>
                  <Text
                    fontSize={'12px'}
                    fontFamily={'PlusJakartaSansMedium'}
                    lineHeight={'16px'}
                    color={'#B4BBC3'}
                  >
                    Reference
                  </Text>
                  <Text
                    fontSize={'12px'}
                    fontFamily={'PlusJakartaSansMedium'}
                    lineHeight={'16px'}
                    color={'#000000'}
                  >
                    {payment?.reference}
                  </Text>
                </Flex>
              </Flex>
            </Box>
          </Box>
          <Flex justifyContent={'flex-end'} gap={3}>
            <Button
              onClick={onClose}
              width={'174px'}
              height={'40px'}
              borderRadius={'12px'}
              bg={'none'}
              border={'1px solid #000000'}
              color={'#000000'}
              fontSize={'12px'}
              fontWeight={'500'}
              fontFamily={'PlusJakartaSansMedium'}
              letterSpacing={0.2}
            >
              Close
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ViewPayment;
